import { gql } from "@apollo/client";
import Link from "next/link";
import styles from "./CollectionLinks.module.scss";

export default function CollectionLinks({
  productCountryCollections,
  productCityCollections,
  location,
}) {
  if (
    productCountryCollections.length === 0 &&
    productCityCollections.length === 0
  )
    return;

  return (
    <div className={styles.CollectionLinks}>
      {productCityCollections.length > 0 && (
        <>
          <h4 className="UIT UITSL UITW1 UITC0">
            More Tours in{" "}
            {location.translation?.name ??
              location.translations.find((l) => l.lang === "en")?.name}
          </h4>
          <div>
            {productCityCollections.map((c, index) => {
              return (
                <Link key={index} href={`/collection/${c.slug}`}>
                  {c.title}
                </Link>
              );
            })}
          </div>
        </>
      )}
      {productCountryCollections.length > 0 && (
        <>
          <h4 className="UIT UITSL UITW1 UITC0">
            More Tours in {location.country.name}
          </h4>
          <div>
            {productCountryCollections.map((c, index) => {
              return (
                <Link key={index} href={`/collection/${c.slug}`}>
                  {c.title}
                </Link>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export const GET_PRODUCT_COLLECTIONS = gql`
  query GetProductCollections($input: ProductCollectionsInput) {
    productCollections(input: $input) {
      records {
        slug
        title
        locations {
          id
          country {
            id
          }
        }
      }
    }
  }
`;
